import React, { useState } from "react";
import styles from "./TextBlock.module.scss";
import Layout from "../../layouts/Layout/Layout";
import THEME from "../../../state/theme";
import { Button } from "../../elements";
import { useCustomState } from "../../../state/state";
import More from "./More";
import Carousel from 'nuka-carousel';
import First from '../../../assets/kaspertech.png';
import Second from '../../../assets/incu1.png';
import Third from '../../../assets/incu2.png';

export default () => {
  const [state, actions] = useCustomState();
  const [modal,setModal] = useState(false);

  const handleOpen = () =>{
    setModal(true);
  }

  const handleClose = () =>{
  setModal(false);
  }
  return (
    <>
    <Layout col="2" padding mode="dark" style={{ background: "rgb(40,40,50)" }}>
         <article className={styles.wrapper}>
        <figure className={styles.image}>
          <div
            className={styles.rectangle1}
            style={{ borderColor: THEME.color }}
          />
          <div className={styles.photo1}>
            <span
              // style={{
              //   background:
              //     "url(" +
              //     state.data.header_bgs.about_video_poster +
              //     ") center/cover",
              // }}
            >
              <Carousel
              autoplay='true'
              wrapAround='true'
              className={styles.caro}
              >
                <div className={styles.imgdiv}><img src={First} /></div>
                <div className={styles.imgdiv}><img src={Second} /></div>
                <div className={styles.imgdiv}><img src={Third} /></div>
              </Carousel>
              </span>
          </div>
        </figure>
      </article>
      <article className={styles.wrapper}>
        <div className={styles.info1} style={{color:"#fff"}}>
          <span className={styles.subtitle} style={{ color: THEME.color }}>
            Startup info
          </span>
          <h2>KasperTech</h2>
          <p  className={styles.paragraph}>
          Following their passion for technology and the zeal to integrate it to make lives better, the team of four engineers from IIIT Surat came together envisioning in creating safer ecosystem through technology, leading to KasperTech. KasperTech is an urban automation startup incubated at Gujarat University Startup And Entrepreneurship Council (GUSEC). We endeavor in creating smart services for homes, offices and automobiles. Our vision is to bring automation technology to every corner of business economically striving for safety while building a Futuristic Present.
          </p>
          <p className={styles.paragraph}>
            <b>
            As technology becomes further integrated into our everyday lives we creating a range of products and services aimed at making our surroundings safer, more efficient and more connected than ever before. We aim at impacting lives by bringing together people, systems and solutions seamlessly.
            </b>
          </p>
          <div className={styles.btn_box}>
            <Button hoverType="solid-gray-tb" click={handleOpen}>
              Read {modal?"less":"more"}
            </Button>
          </div>
        </div>
      </article>
    </Layout>
    <More modal={modal} handleClose={handleClose} info={1} />
    </>
  );
};
